import { setUser } from '@firsttable/functions';
import { ApolloClient, gql } from '@apollo/client';
import { resetAmplitudeUser } from '@/lib/analytics/amplitude/client';

const LOG_OUT = gql`
  mutation logOutMember {
    logOut {
      status
      message
    }
  }
`;

const logoutUser = async (client: ApolloClient<any>) => {
  // log out of API, remove JWTs and remove active bookings
  client.mutate({ mutation: LOG_OUT }).catch((e) => e);

  // remove user from local store
  resetAmplitudeUser();
  setUser(null);
  // reset apollo client store to defaults
  await client.cache.reset();
  // reload the page and let the route handle the redirecting
  window.location.reload();
};

export { logoutUser };
